const dateFormatters = {
  mainWithTimeFormat: 'yyyy-MM-dd HH:mm aa',
  mainTimeFormat: 'HH:mm aa',
};
export default dateFormatters;
